import { FC, useState, ChangeEvent, useLayoutEffect, useMemo, useCallback } from 'react';
import { Loading, Modal, Table } from '../../../../components';
import { TVeiculoModelo, getAdminVehicleModels } from '../../../../services';
import { RegistrationPage } from '../../templates';
import { RegistrationEntities, useFilteredItems } from '../../../../utils';
import { TableWrapper } from '../../Registration.styles';
import { useToastStore } from '../../../../stores';

const RegistrationModels: FC = () => {
	const { setToast } = useToastStore();
	const [loading, setLoading] = useState<boolean>(false);
	const [vehicleModels, setVehicleModels] = useState<TVeiculoModelo[]>([]);
	const [openDeleteModal, setOpenDeleteModal] = useState(false);
	const [searchTerm, setSearchTerm] = useState('');
	const { filteredItems, filterLoading } = useFilteredItems({
		items: vehicleModels,
		searchTerm,
		status: null,
		filterFn: useCallback((item: TVeiculoModelo, searchTerm: string) => {
			let matchesSearchTerm = true;

			if (searchTerm) {
				const matchesName =
					item.veiculoModelo?.toLowerCase().includes(searchTerm.toLowerCase()) ?? false;
				const matchesFipe =
					item.codigoModeloFipe?.toLowerCase().includes(searchTerm.toLowerCase()) ?? false;

				matchesSearchTerm = matchesName || matchesFipe;
			}

			return matchesSearchTerm;
		}, []),
	});

	const tableColumns = useMemo(
		() => [
			{ id: 'brand', label: 'Marca' },
			{ id: 'model', label: 'Modelo' },
			{ id: 'fipe', label: 'FIPE' },
			//{ id: 'actions', label: 'Ações' },
		],
		[]
	);

	const rowMapper = useCallback(
		(item: TVeiculoModelo) => ({
			brand: { value: item.veiculoMarca?.veiculoMarca, rawValue: item.veiculoMarca?.veiculoMarca },
			model: { value: item.veiculoModelo, rawValue: item.veiculoModelo },
			fipe: { value: item.codigoModeloFipe, rawValue: item.codigoModeloFipe || '' },
			/*
			actions: {
				value: (
					<ActionsContainer>
						<Tooltip title='Editar' placement='top' arrow>
							<Link to=''>
								<Button variant='icon' icon={<EditOutlined fontSize='inherit' />} />
							</Link>
						</Tooltip>
						<Tooltip title='Excluir' placement='top' arrow>
							<div>
								<Button
									variant='icon'
									icon={<DeleteOutlined fontSize='inherit' />}
									onClick={() => setOpenDeleteModal(true)}
								/>
							</div>
						</Tooltip>
					</ActionsContainer>
				),
			},
			*/
		}),
		[]
	);

	const handleSearchChange = (e: ChangeEvent<HTMLInputElement>) => {
		setSearchTerm(e.target.value);
	};

	const handleDelete = () => {};

	const MemoizedTable = useMemo(
		() => <Table paginate columns={tableColumns} rows={filteredItems.map(rowMapper)} />,
		[filteredItems, rowMapper, tableColumns]
	);

	useLayoutEffect(() => {
		const fetchData = async () => {
			setLoading(true);
			try {
				const response = await getAdminVehicleModels();
				const sorted = (response || []).sort((a, b) => {
					if (a.veiculoModelo! < b.veiculoModelo!) {
						return -1;
					}
					if (a.veiculoModelo! > b.veiculoModelo!) {
						return 1;
					}
					return 0;
				});
				setVehicleModels(sorted || []);
			} catch {
				setToast({
					message: 'Erro ao buscar os modelos!',
					variant: 'error',
				});
			} finally {
				setTimeout(() => setLoading(false), 500);
			}
		};

		fetchData();
	}, [setToast]);

	if (loading) return <Loading fullScreen />;

	return (
		<RegistrationPage
			entity={RegistrationEntities.model}
			searchTerm={searchTerm}
			disableNewButton={true}
			onChange={handleSearchChange}
		>
			<>
				<Modal
					open={openDeleteModal}
					onClose={() => setOpenDeleteModal(false)}
					title='Confirmação!'
					primaryButtonText='Sim'
					secondaryButtonText='Não'
					onPrimaryButtonClick={handleDelete}
					onSecondaryButtonClick={() => setOpenDeleteModal(false)}
				>
					Deseja realmente excluir?
				</Modal>
				<TableWrapper>{filterLoading ? <Loading /> : MemoizedTable}</TableWrapper>
			</>
		</RegistrationPage>
	);
};

export default RegistrationModels;
